import Vue from 'vue'
import VueRouter from 'vue-router'
import Content from '../views/Content.vue'
import Redirect from '../views/Redirect.vue'
import Startup from '../views/Startup.vue'
import Login from '../views/login/Login.vue'
import Home from '../views/map/Home.vue'
import NotFound from '../views/error/NotFound.vue'
import LicenseError from '../views/error/LicenseError.vue'
import store from '../store/index'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [
  {
    path: '/error',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'NotFound',
    },
  },
  {
    path: '/licenseError',
    name: 'LicenseError',
    component: LicenseError,
    meta: {
      title: 'LicenseError',
    },
  },
  {
    path: '/redirect/:viewerName/:type',
    name: 'Redirect',
    component: Redirect,
    meta: {
      title: 'Redirect',
    },
  },
  {
    path: '/startup/:viewerName/:type',
    name: 'StartUp',
    component: Startup,
    meta: {
      title: 'Startup',
    },
  },
  {
    path: '/:viewer',
    component: Content,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: { title: 'Login' },
      },
      {
        path: 'home',
        name: 'Home',
        component: Home,
        meta: {
          title: 'Home',
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/error',
  },
]

async function validateLicense () {
  try {
    const response = await axios.get('validateLicense')
    if (response.data.success) {
      store.dispatch('setValidLicense', true)
      return Promise.resolve(true)
    }
    store.dispatch('setValidLicense', false)
    return Promise.resolve(false)
  } catch (error) {
    store.dispatch('setValidLicense', false)
    router.push('/licenseError')
    return Promise.resolve(false)
  }
}

const router = new VueRouter({
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.path.startsWith('/redirect')) {
    const valid = await validateLicense()
    if (!valid) {
      store.dispatch('setValidLicense', false)
      next('/licenseError')
      return
    }
  }
  const validLicense = store.getters.getValidLicense
  if (!validLicense && to.path !== '/licenseError') {
    const valid = await validateLicense()
    if (!valid) {
      next('/licenseError')
      return
    }
  }
  if (to.path.includes('/startup')) {
    next()
    return
  }
  if (!(to.path.startsWith('/error') || to.path.startsWith('/redirect') || to.path.startsWith('/licenseError'))) {
    let viewerName = null
    let type = null
    if (to.path.includes('/login')) {
      viewerName = to.path.replace('/login', '')
      type = 'login'
    } else {
      viewerName = to.path.replace('/home', '')
      type = 'home'
    }
    if (to.path.includes('/startup')) {
      viewerName = viewerName.replace('startup/', '')
      next('/startup' + viewerName + '/' + type)
      return
    }
    viewerName = viewerName.replace('/', '')
    if (viewerName !== store.getters.getViewerName) {
      next('/redirect/' + viewerName + '/' + type)
      return
    }
  }
  if (to.path.startsWith('/redirect')) {
    next()
    return
  }
  if (to.path.includes('/error')) {
    next()
    return
  }
  if (to.path.startsWith('/licenseError')) {
    next()
    return
  }
  if ((store.getters.getHasLogin === 1 || store.getters.getHasLogin === 2) && to.path === '/' + store.getters.getViewerName + '/login' && !store.getters.getLoggedInUser) {
    next()
    return
  }
  if (to.path === '/' + store.getters.getViewerName + '/login' && (store.getters.getHasLogin === 0 || store.getters.getLoggedInUser)) {
    next('/' + store.getters.getViewerName + '/home')
    return
  }
  if (to.path === '/' + store.getters.getViewerName + '/home' && (store.getters.getHasLogin === 1) && !store.getters.getLoggedInUser) {
    next('/' + store.getters.getViewerName + '/login')
    return
  }
  if (to.path === '/' + store.getters.getViewerName + '/home') {
    next()
  } else if (to.path === '/' + store.getters.getViewerName) {
    next('/' + store.getters.getViewerName + '/home')
  } else {
    next('error')
  }
})
export default router
